import dayjs from 'dayjs';

export const DISCREPANCY_DATETIME_FORMAT = 'M/D/YYYY h:mmA';

type UserLike = { full_name?: string; email?: string } | null | undefined;

export const formatUserName = (user: UserLike) =>
	user?.full_name || user?.email || '—';

export const formatQuestionDateTime = (
	timestamp: string | null | undefined
) =>
	timestamp ? dayjs(timestamp).format(DISCREPANCY_DATETIME_FORMAT) : null;

export const formatUserWithTimestamp = (
	user: UserLike,
	timestamp: string | null | undefined
) => {
	const name = formatUserName(user);
	const when = formatQuestionDateTime(timestamp);
	if (!when) return name;
	if (name === '—') return when;

	return `${name} · ${when}`;
};
